import { render, staticRenderFns } from "./Caroussel.vue?vue&type=template&id=59ce4f7c&"
import script from "./Caroussel.vue?vue&type=script&lang=js&"
export * from "./Caroussel.vue?vue&type=script&lang=js&"
import style0 from "./Caroussel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports